import { createRouter, createWebHistory } from 'vue-router'
import RecientesView from '../views/RecientesView.vue'
import AlbumsView from '../views/AlbumsView.vue'
import CancionesView from '../views/CancionesView.vue'
import EstacionesView from '../views/EstacionesView.vue'
import ArtistasView from '../views/ArtistasView.vue'
import MetalView from '../views/MetalView.vue'
import BaileView from '../views/BaileView.vue'
import RockView from '../views/RockView.vue'
import BaladasView from '../views/BaladasView.vue'
const routes = [ 
  {
    path: '/artistas/:access_token(#access_token=[a-zA-Z0-9]+&expires=[0-9])?',
    name: 'artistas',
    component: ArtistasView
  },
  {
    path: '/albums/:access_token(#access_token=[a-zA-Z0-9]+&expires=[0-9])?',
    name: 'albums',
    component: AlbumsView
  },
  {
    path: '/canciones/:access_token(#access_token=[a-zA-Z0-9]+&expires=[0-9])?',
    name: 'canciones',
    component: CancionesView,
  },
  {
    path: '/estaciones/:access_token(#access_token=[a-zA-Z0-9]+&expires=[0-9])?',
    name: 'estaciones',
    component: EstacionesView,
  },
  {
    path: '/playlist/metal/:access_token(#access_token=[a-zA-Z0-9]+&expires=[0-9])?',
    name: 'metal',
    component: MetalView
  },
  {
    path: '/playlist/baile/:access_token(#access_token=[a-zA-Z0-9]+&expires=[0-9])?',
    name: 'baile',
    component: BaileView
  },
  {
    path: '/playlist/rock/:access_token(#access_token=[a-zA-Z0-9]+&expires=[0-9])?',
    name: 'rock',
    component: RockView
  },
  {
    path: '/playlist/baladas/:access_token(#access_token=[a-zA-Z0-9]+&expires=[0-9])?',
    name: 'baladas',
    component: BaladasView
  },
  {
    path: '/:access_token(#access_token=[a-zA-Z0-9]+&expires=[0-9])?',
    name: 'home',
    component: RecientesView
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
